import { defineStore } from 'pinia';

const SETTINGS_VISIBLE_KEY = 'debugApiErrorsSettingVisible';
const API_ERRORS_ENABLED_KEY = 'debugApiErrorsEnabled';

function readBoolean(key) {
  try {
    return localStorage.getItem(key) === 'true';
  } catch {
    return false;
  }
}

function writeBoolean(key, value) {
  try {
    localStorage.setItem(key, String(Boolean(value)));
  } catch {
    // Storage can be unavailable in private or restricted browser contexts.
  }
}

function removeSetting(key) {
  try {
    localStorage.removeItem(key);
  } catch {
    // Storage can be unavailable in private or restricted browser contexts.
  }
}

export const useDebugStore = defineStore('debug', {
  state: () => ({
    apiErrorsSettingVisible: readBoolean(SETTINGS_VISIBLE_KEY),
    apiErrorsEnabled: readBoolean(API_ERRORS_ENABLED_KEY)
  }),
  actions: {
    toggleApiErrorsSettingVisibility() {
      this.apiErrorsSettingVisible = !this.apiErrorsSettingVisible;
      writeBoolean(SETTINGS_VISIBLE_KEY, this.apiErrorsSettingVisible);
    },
    setApiErrorsEnabled(value) {
      this.apiErrorsEnabled = Boolean(value);
      writeBoolean(API_ERRORS_ENABLED_KEY, this.apiErrorsEnabled);
    },
    resetDebugSettings() {
      this.apiErrorsSettingVisible = false;
      this.apiErrorsEnabled = false;
      removeSetting(SETTINGS_VISIBLE_KEY);
      removeSetting(API_ERRORS_ENABLED_KEY);
    }
  }
});
